var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_992651",
    clipPath: "url(#clip0_2483_21027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5 0C4.5371 0 0.5 4.0371 0.5 9C0.5 13.9629 4.5371 18 9.5 18C14.4629 18 18.5 13.9622 18.5 9C18.5 4.0378 14.4629 0 9.5 0ZM9.5 16.6057C5.30674 16.6057 1.89426 13.194 1.89426 9C1.89426 4.80604 5.30674 1.39426 9.5 1.39426C13.6933 1.39426 17.1057 4.80604 17.1057 9C17.1057 13.194 13.694 16.6057 9.5 16.6057Z",
    fill: "#FF7F29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9856 8.24007H10.1971V5.45154C10.1971 5.06672 9.88548 4.75439 9.49996 4.75439C9.11444 4.75439 8.80281 5.06672 8.80281 5.45154V8.24007H6.01429C5.62876 8.24007 5.31714 8.55239 5.31714 8.93721C5.31714 9.32203 5.62876 9.63436 6.01429 9.63436H8.80281V12.4229C8.80281 12.8077 9.11444 13.12 9.49996 13.12C9.88548 13.12 10.1971 12.8077 10.1971 12.4229V9.63436H12.9856C13.3712 9.63436 13.6828 9.32203 13.6828 8.93721C13.6828 8.55239 13.3712 8.24007 12.9856 8.24007Z",
    fill: "#FF7F29"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2483_21027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMore);
export default __webpack_public_path__ + "static/media/add_more.704f5b4c4e62a3da887b817d46b885ad.svg";
export { ForwardRef as ReactComponent };